<template>
  <div>

    <div class="services style-3 home s-2 bottom-3">
      <div class="container clearfix">

        <div class="eight columns bottom-3">
          <div class="item bottom-3">
            <div class="circle float-left"><a href="#"><i class="icon-resize-full"></i></a></div>
            <div class="data float-right">
              <h4><a href="#">{{ $t('home_grow_1') }}</a></h4>
              <p>{{ $t('home_grow_2') }}</p>
            </div>
          </div>
        </div>

        <div class="eight columns bottom-3">
          <div class="item bottom-3">
            <div class="circle float-left"><a href="#"><i class="icon-map-marker"></i></a></div>
            <div class="data float-right">
              <h4><a href="#">{{ $t('home_operate_1') }}</a></h4>
              <p>{{ $t('home_operate_2') }}</p>
            </div>
          </div>
        </div>

      </div>

      <div class="container clearfix">

        <div class="eight columns bottom-3">
          <div class="item bottom-3">
            <div class="circle float-left"><a href="#"><i class="icon-time"></i></a></div>
            <div class="data float-right">
              <h4><a href="#">{{ $t('home_budget_1') }}</a></h4>
              <p>{{ $t('home_budget_2') }}</p>
              <br/>
              <p>{{ $t('home_budget_3') }}</p>
            </div>
          </div>
        </div>

        <div class="eight columns bottom-3">
          <div class="item bottom-3">
            <div class="circle float-left"><a href="#"><i class="icon-search"></i></a></div>
            <div class="data float-right">
              <h4><a href="#">{{ $t('home_task_1') }}</a></h4>
              <p>{{ $t('home_task_2') }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <contact-banner :ctatext="$t('banner_ctatext2')"></contact-banner>

      <div class="container main-content clearfix">
          <div class="shortcodes">
              <div class="sixteen columns bottom-3">
                  <div class="qoute">
                      <div class="one columns omega">&nbsp;</div>
                      <div class="seven columns omega">
                          <h4>Discover your Office macros!</h4>
                          <p>Educate your macro developers, reduce your security posture, close audit issues!</p>
                      </div>
<!--                      {{ $t('cccc') }}-->
                      <div class="seven columns alpha">
                          <a href="https://knowourmacros.com/" target="_blank"
                                       class="button medium color">
                              Learn more about KnowOurMacros
                          </a>
                      </div>
                      <div class="one columns omega">&nbsp;</div>
                  </div>
              </div>
          </div>
      </div>

    <div class="container main-content clearfix">
      <div class="shortcodes">
        <div class="contents">
          <p>
            <strong>{{ $t('home_brand_1') }} - </strong>
            {{ $t('home_brand_2') }}
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ContactBanner from '../utilities/ContactBanner'

export default {
  name: 'Home',
  components: { ContactBanner }
}
</script>

<style>
</style>
